import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../../BlockTabs';
import { Loader } from '../../components';
import StackedBarChart from '../../charts/StackedBarChart';
import DevicePerSdkVersion from './version/DevicePerSdkVersion';
import DevicePerOsVersion from './version/DevicePerOsVersion';
import DevicePerSdkVersionEvolution from './version/DevicePerSdkVersionEvolution';
import DevicePerOsVersionEvolution from './version/DevicePerOsVersionEvolution';
import { useGetPublisherAdminLocationStatusPerOsVersionQuery } from '../../../api/publisherAdminApiSlice';
import { locationStatusDataToChartData } from '../../../services/data/charts/locationStatusDataToCharData';

const LocationStatusPerOsVersion = ({publisherId}) => {
  const { t } = useTranslation();
  const { data=[], isSuccess, isError, retry } = useGetPublisherAdminLocationStatusPerOsVersionQuery(publisherId)
  const iosData = locationStatusDataToChartData("ios")(data)
  const androidData = locationStatusDataToChartData("android")(data)

  return (
    <BlockTabs title={t('version.location_status_per_os_version')} defaultActiveKey="android">
      <Loader success={true} error={false} minHeight={"100%"} key="ios" title="ios">
        <StackedBarChart data={iosData} />
      </Loader>
      <Loader success={true} error={false} minHeight={"100%"} key="android" title="android">
        <StackedBarChart data={androidData}/>
      </Loader>
    </BlockTabs>
  )
}

const Version = ({publisherId}) => {
  return (
    <>
      <Row>
        <DevicePerSdkVersion publisherId={publisherId} as={Col} md={4}/>
        <DevicePerSdkVersionEvolution publisherId={publisherId} as={Col} md={8}/>
      </Row>
      <Row>
        <DevicePerOsVersion publisherId={publisherId} as={Col} md={4}/>
        <DevicePerOsVersionEvolution publisherId={publisherId} as={Col} md={8}/>
      </Row>
      <LocationStatusPerOsVersion publisherId={publisherId}/>
    </>
  )
}

export default Version
